export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const RELEASE = process.env.REACT_APP_RELEASE;
export const BLOCKSTREAM_EXPLORER_URL = process.env.REACT_APP_BLOCKSTREAM_EXPLORER_URL;